import GuidanceRegistry from '../guidance-registry.js';

GuidanceRegistry.register({
    type: "action-item-ewf-guided-setup-online-enrollment-dates",
    prompt: 'Enter the start and end dates for your upcoming open enrollment, which determines when employees can go online and enroll in their benefits. Click Save.',
    briefDescription: 'Enrollment Dates',
    details: 'This is when your participants will be able to make their new elections, or waive, for the upcoming plan year.',
    openAction: { 
        text: "View Online Enrollment Dates",
        url: (guidanceItem) => `/employer/${guidanceItem.employerId}/general`,
        row: 'Enrollment Information'
    },
    completeAction: {
    },
});


// WEBPACK FOOTER //
// ./src/guidance/items/guidance-online-enrollment-dates.js